<a class="back-btn" (click)="goBack()">{{ 'general.back' | translate }}</a>
<!-- Title -->
<h3 class="ui-headline">{{ (enabled2FA ? '2fa.disable.title' : '2fa.enable.title') | translate }}</h3>
<p *ngIf="!editPhoneNumberView">
  {{ (phoneNumber?.length ? '2fa.phone_setup.existing_number.p' : '2fa.phone_setup.p') | translate }}
</p>
<p *ngIf="editPhoneNumberView">{{ '2fa.phone_setup.p' | translate }}</p>
<!-- Existing phone -->
<div class="form-row phone-details" *ngIf="!editPhoneNumberView; else manuallyEnterPhoneNumber">
  <label class="form-label">{{ '2fa.phone_setup.phone' | translate }}</label>
  <p class="saved-number">{{ phoneNumber }}</p>
  <a *ngIf="!has3AAccountMinProspect" (click)="changePhoneNumber()">{{ '2fa.phone_setup.changePhone' | translate }}</a>
</div>
<!-- Input field for phone number -->
<ng-template #manuallyEnterPhoneNumber>
  <form [formGroup]="phoneNumberForm">
    <div class="form-row">
      <label class="form-label">{{ '2fa.phone_setup.phone' | translate }}</label>
      <input
        class="form-input"
        formControlName="phoneNumber"
        type="tel"
        [placeholder]="'2fa.phone_setup.placeholder' | translate"
        [ngClass]="{ error: phoneNumberForm.invalid && phoneNumberForm.get('phoneNumber').touched }"
      />
    </div>
    <p
      class="empty error"
      for="password"
      *ngIf="phoneNumberForm.get('phoneNumber').hasError('invalidNumber') && phoneNumberForm.get('phoneNumber').touched"
    >
      {{ 'personal.error.bad_phone' | translate }}
    </p>
  </form>
</ng-template>
<!-- CTA -->
<button (click)="send()" class="ui-button" [class.loading]="loading">
  <span class="icon-i-windmill"></span>
  {{ '2fa.phone_setup.cta' | translate }}
</button>
